import React, { ComponentPropsWithRef } from 'react'
import { useCommonCtx } from '../context/useCommonCtx'
import { useTranslation } from '../i18n/useTranslation'
import { ScaleSlider } from '../app/360/ScaleSlider'
import { ScaleItem } from '../app/360/types'
import { TKeys } from '../i18n/types'
import { AnswserScoreType, FINAL_NPS_KEY, NO_SCORE } from '../services/types'
import { isMobilePortrait } from '../utils'

interface Props extends ComponentPropsWithRef<'div'> {}

const MAX_VALUE = 10 as AnswserScoreType['Score']
const AVG_VALUE = 5 as AnswserScoreType['Score']
const MIN_VALUE = 0 as AnswserScoreType['Score']
const SCORE_PREFIX = 'lvlSC10x'
const MARKS_VALUES = [MIN_VALUE, 2, 4, 6, 8 , MAX_VALUE]
const options: ScaleItem[] = Array(MAX_VALUE+1)
    .fill(0)
    .map((_, i) => ({
        key: `${SCORE_PREFIX}${i}` as TKeys,
        value: i as AnswserScoreType['Score'],
    }))

export const NPS360 = (p: Props) => {
    const commons = useCommonCtx()
    const t = useTranslation(commons)

    const {
        state: {
            params: { brandParams },
        },
        setScannedItems,
        scannedItems,
    } = commons

    const item = scannedItems.find(
        (s) => s.RefQuestion === FINAL_NPS_KEY
    ) as AnswserScoreType


    const brandImgSrc = isMobilePortrait()
        ? brandParams['brandImageUrlMobile']
        : brandParams['brandImageUrl']

    return (
        <div className="flex flex-1 flex-col justify-around items-center">
            {/* <Box className="flex flex-1 flex-col justify-center items-center"/> */}
            <div className={'border-0 border-black border-solid p-2 mt-4 mb-6'}>
                {/* <img className={`w-full pointer-events-none`} src={Cover} /> */}
                <img
                    className={`w-full pointer-events-none`}
                    src={brandImgSrc}
                />
            </div>
            <ScaleSlider
                // className="flex-1"
                withEmoji
                withEndScale
                withCustomMarksLabels={false}
                marksValues={MARKS_VALUES}
                options={options}
                noScoreOption={{
                    key: 'lvlSC10x00' as TKeys,
                    value: NO_SCORE,
                }}
                scaleValue={item.Score}
                minValue={MIN_VALUE}
                maxValue={MAX_VALUE}
                avgValue={AVG_VALUE}
                onPickScale={(v) =>
                    setScannedItems((prev) =>
                        prev.map((s) =>
                            s.RefQuestion === item.RefQuestion
                                ? { ...s, Score: v }
                                : s
                        )
                    )
                }
            />
        </div>
    )
}
